module.exports = __webpack_public_path__ + "static/img/zhong7.123e56a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong7.png
// module id = X2dQ
// module chunks = 16